import ProjectsUser from "../../components/user/projects/ProjectsUser";
import UserTemplate from "../../views/UserTemplate";

const ProjectsUserPage = () => {
  return (
    <UserTemplate>
      <ProjectsUser />
    </UserTemplate>
  );
};

export default ProjectsUserPage;
